module.exports = __webpack_public_path__ + "static/pie_painter_10-ab17fc20b6f5612c828330e68902a831.png";